var AcHookableFilters = /** @class */ (function () {
    function AcHookableFilters() {
        this.filters = {};
    }
    AcHookableFilters.prototype.addFilter = function (name, callback, priority) {
        if (priority === void 0) { priority = 10; }
        if (!this.filters.hasOwnProperty(name)) {
            this.filters[name] = {};
        }
        if (!this.filters[name].hasOwnProperty(priority)) {
            this.filters[name][priority] = [];
        }
        this.filters[name][priority].push(callback);
    };
    AcHookableFilters.prototype.applyFilters = function (name, value, payload) {
        var _this = this;
        if (payload === void 0) { payload = {}; }
        if (!this.filters.hasOwnProperty(name)) {
            return value;
        }
        Object.keys(this.filters[name]).forEach(function (priority) {
            _this.filters[name][parseInt(priority)].forEach(function (cb) {
                value = cb(value, payload);
            });
        });
        return value;
    };
    return AcHookableFilters;
}());
export default AcHookableFilters;
